<template>
  <PageTabs
    v-model:tabKey="activeKey"
    tabName="collection"
    :title="$t('wo-de-shou-cang')"
  >
    <template #rightExtra>
      <XSearch
        v-model="searchFrom.keyword"
        class="-mt-[6px]"
        :placeholder="$t('qing-shu-ru-guan-jian-ci')"
        @search="handleOnSearch"
      />
    </template>
    <div v-if="activeKey === COLLECTION_MAP.SOURCE" class="mb-[16px]">
      <TagSelect v-model="mediaTypeState" name="resource" :hasAll="false" />
    </div>
    <div
      class="content"
      :class="{
        'list-source': activeKey === COLLECTION_MAP.SOURCE,
        'list-person': mediaTypeState === RESOURCE_TYPE_CONFIG.PERSON,
        'list-timbre': mediaTypeState === RESOURCE_TYPE_CONFIG.TIMBRE,
      }"
    >
      <ListCard
        ref="cardListRef"
        :list="list"
        :total="total"
        :loading="loading.global"
        selectKey="model_id"
        :patch="mediaTypeState !== RESOURCE_TYPE_CONFIG.MATERIAL"
        @select-change="onSelectChange"
        @load-more="loadMore"
        @card-click="onCoverClick"
      >
        <template #cover="{ dataSource }">
          <div
            :class="{
              tool: mediaTypeState !== RESOURCE_TYPE_CONFIG.TIMBRE,
              'timbre-like': mediaTypeState === RESOURCE_TYPE_CONFIG.TIMBRE,
            }"
          >
            <a-popover
              v-if="
                dataSource.isBrand &&
                mediaTypeState !== RESOURCE_TYPE_CONFIG.TIMBRE
              "
            >
              <template #content>{{ $t('pin-pai-gui-fan') }}</template>
              <div class="icon-item">
                <iconpark-icon name="icon-crown" size="16"></iconpark-icon>
              </div>
            </a-popover>
            <div class="icon-item collection" :class="{ favorite: true }">
              <XCollect
                v-model="dataSource.like"
                class="collect"
                :data="dataSource"
                :params="{
                  model_id: dataSource.model_id,
                  model_type: dataSource.model_type,
                  media_type: dataSource.media_type,
                  source: dataSource.source,
                  resource_type: dataSource.resource_type,
                  is_user_upload: dataSource.is_user_upload,
                }"
                :class="{ active: dataSource.like }"
                @reload="(ids) => cancelReload([ids])"
              />
            </div>
            <div
              v-if="
                !dataSource?.isDelete &&
                ((checkPermission(ActionListKey.COLLECTION_SHARE) &&
                  allowShare) ||
                  canShare)
              "
              class="share"
            >
              <TemplateShare
                :id="dataSource?.id"
                :isCard="true"
                :title="getCardName()"
                :showExtra="activeKey === COLLECTION_MAP.PIECES"
                :hasShare="true"
                :disabled="canShare && dataSource?.is_user_upload"
                :disabledText="
                  $t('ge-ren-chuang-jian-de-ren-wu-zan-bu-zhi-chi-fen-xiang')
                "
                :linkUrl="
                  activeKey !== COLLECTION_MAP.PIECES &&
                  mediaTypeState !== RESOURCE_TYPE.PERSON
                    ? undefined
                    : getShareUrl(dataSource)
                "
                :params="{
                  model_type: activeKey,
                  is_user_upload: dataSource.is_user_upload,
                  share_ids: [dataSource.model_id],
                  ...(activeKey === COLLECTION_MAP.SOURCE && {
                    media_type:
                      mediaTypeState === RESOURCE_TYPE.MATERIAL
                        ? dataSource.media_type
                        : undefined,
                    resource_type: mediaTypeState,
                  }),
                }"
                :shareToInnerUser="
                  activeKey === COLLECTION_MAP.SOURCE &&
                  mediaTypeState === RESOURCE_TYPE.PERSON
                    ? false
                    : true
                "
                :trackParams="{
                  target: getTargetForEventTracking(activeKey, mediaTypeState),
                  dataTd: dataSource.id,
                  dataTitle: dataSource.title,
                }"
                :shareToOuterUser="
                  hasActionPermission('my_collection_share_to_outer_user')
                "
                @click.stop
              />
            </div>
          </div>
          <!-- 资源未删除 -->
          <div v-if="!dataSource?.isDelete">
            <div
              v-if="
                activeKey === COLLECTION_MAP.PIECES_TEMPLATE &&
                checkPermission(ActionListKey.COLLECTION_USE_TEMPLATE) &&
                !dataSource?.isDelete
              "
              class="template"
              :class="{
                'w-[158px]': dataSource.limited,
              }"
            >
              <iconpark-icon
                :name="dataSource.limited ? 'eye-fill' : 'edit'"
                class="icon-edit"
              ></iconpark-icon>
              <span class="label">
                {{
                  dataSource.limited
                    ? $t('ban-quan-xiang-guan-zhi-du-mo-ban')
                    : $t('chuang-zuo-tong-kuan')
                }}
              </span>
            </div>
            <MusicPlayer
              v-if="allowMusicPlay"
              :id="dataSource.id"
              :url="dataSource?.url?.[0]"
            />

            <Player
              v-if="dataSource.url?.[0] && showVideoIcon"
              ref="player"
              class="play-button absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] opacity-0"
              :url="dataSource.url?.[0]"
              @click="playVideo(dataSource)"
            />
            <div class="operation">
              <div
                v-if="allowPreview && dataSource?.url?.length"
                class="icon-item eye"
                :class="{
                  'eye-only': !(
                    checkPermission(ActionListKey.COLLECTION_SHARE) &&
                    [COLLECTION_MAP.SOURCE].includes(activeKey)
                  ),
                }"
              >
                <Eye :data="dataSource" class="clear-collect-position" />
              </div>
              <div v-if="activeKey === COLLECTION_MAP.OPUS" class="eye">
                <ProjectEye :data="dataSource" />
              </div>
              <div
                v-if="
                  activeKey === COLLECTION_MAP.SOURCE &&
                  mediaTypeState === RESOURCE_TYPE.STUDIO
                "
                class="eye"
                :class="{
                  'eye-only': !(
                    checkPermission(ActionListKey.COLLECTION_SHARE) &&
                    [COLLECTION_MAP.SOURCE].includes(activeKey)
                  ),
                }"
              >
                <!--场景-->
                <Eye :data="dataSource" class="clear-collect-position" />
              </div>

              <!-- 成片模板 -->
              <div
                v-if="
                  [COLLECTION_MAP.PIECES_TEMPLATE].includes(activeKey) &&
                  ((dataSource?.url?.length &&
                    checkPermission(ActionListKey.COLLECTION_PLAY)) ||
                    checkPermission(ActionListKey.COLLECTION_SHARE))
                "
                class="more-menu"
              >
                <a-dropdown
                  placement="bottomRight"
                  destroyPopupOnHide
                  @click.stop.prevent=""
                >
                  <a class="ant-dropdown-link" @click.prevent>
                    <iconpark-icon name="dash" size="20"></iconpark-icon>
                  </a>
                  <template #overlay>
                    <a-menu
                      mode="vertical"
                      @click="(e) => handleOnMenuClick(e, dataSource)"
                    >
                      <a-menu-item
                        v-if="
                          dataSource?.url?.length &&
                          checkPermission(ActionListKey.COLLECTION_PLAY)
                        "
                        key="play"
                      >
                        {{ $t('bo-fang-shi-pin') }}
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
              <!-- 作品 -->
              <div
                v-else-if="
                  [COLLECTION_MAP.OPUS].includes(activeKey) &&
                  dataSource?.url?.length
                "
                class="more-menu"
              >
                <a-dropdown
                  placement="bottomRight"
                  destroyPopupOnHide
                  @click.stop.prevent=""
                >
                  <a class="ant-dropdown-link" @click.prevent>
                    <iconpark-icon name="dash" size="20"></iconpark-icon>
                  </a>
                  <template #overlay>
                    <a-menu
                      mode="vertical"
                      @click="(e) => handleOnMenuClick(e, dataSource)"
                    >
                      <!-- <a-sub-menu
                      v-if="dataSource?.tags?.length"
                      key="open-and-locate"
                      title="打开并定位至"
                    >
                      <template #expandIcon></template>
                      <a-menu-item
                        v-for="item in dataSource.tags"
                        :key="item.key"
                      >
                        {{ item.label }}工程
                      </a-menu-item>
                    </a-sub-menu> -->
                      <a-menu-item v-if="dataSource?.url?.length" key="play">
                        {{ $t('bo-fang-shi-pin') }}
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
              <!-- 成片 -->
              <div
                v-else-if="[COLLECTION_MAP.PIECES].includes(activeKey)"
                class="more-menu"
              >
                <a-dropdown
                  placement="bottomRight"
                  destroyPopupOnHide
                  @click.stop.prevent=""
                >
                  <a class="ant-dropdown-link" @click.prevent>
                    <iconpark-icon name="dash" size="20"></iconpark-icon>
                  </a>
                  <template #overlay>
                    <a-menu
                      mode="vertical"
                      @click="(e) => handleOnMenuClick(e, dataSource)"
                    >
                      <a-menu-item
                        v-if="dataSource.source === COLLECTION_SOURCE.PERSON"
                        key="open"
                        :disabled="dataSource?.project_is_delete"
                      >
                        {{ $t('da-kai-zuo-pin') }}
                      </a-menu-item>
                      <a-menu-item
                        v-if="
                          dataSource?.url?.length &&
                          checkPermission(ActionListKey.COLLECTION_PLAY)
                        "
                        key="play"
                      >
                        {{ $t('bo-fang-shi-pin') }}
                      </a-menu-item>

                      <a-menu-item
                        v-if="checkPermission(ActionListKey.COLLECTION_SAVE)"
                        key="save"
                      >
                        {{ $t('ling-cun-xin-zuo-pin-bing-bian-ji') }}
                      </a-menu-item>
                      <a-menu-item
                        v-if="
                          checkPermission(ActionListKey.COLLECTION_TEMPLATE)
                        "
                        key="create"
                      >
                        {{ $t('chuang-jian-cheng-pian-mo-ban') }}
                      </a-menu-item>
                      <!-- <a-menu-item
                        v-if="dataSource?.url?.length"
                        key="download"
                      >
                        {{ $t('xia-zai-shi-pin') }}
                      </a-menu-item> -->
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="source-delete">
              <iconpark-icon
                name="source-delete"
                class="icon-delete"
              ></iconpark-icon>

              <span class="label ml-[5px]">{{
                $t('yuan-wen-jian-yi-shan-chu')
              }}</span>
            </div>
            <div
              class="more-menu absolute top-[10px]"
              style="opacity: 1; right: 5px"
              @click="cancelLike(dataSource)"
            >
              <iconpark-icon
                name="close"
                class="text-[#A7A9AE] text-[16px]"
              ></iconpark-icon>
            </div>
          </div>
        </template>
        <template #defaultBar>
          <div
            v-if="
              showSourceSelect &&
              hasActionPermission('my_collection_source_from')
            "
            class="flex gap-x-[20px] mr-[20px]"
          >
            <TagSelect
              v-model="searchFrom.source"
              :name="sourceName"
              :label="$t('lai-yuan')"
              type="primary"
            />
          </div>
        </template>
        <template #right="{ dataSource }">
          <a-popover v-if="checkDownloadable(dataSource)">
            <template #content>{{ $t('xia-zai-shi-pin') }}</template>
            <div
              class="text-font-1 cursor-pointer w-[32px] flex-y-center justify-center h-[32px] rounded-[8px] hover:bg-back-2"
            >
              <iconpark-icon
                name="download"
                size="18"
                @click.stop="onDownloadVideo([dataSource.id])"
              ></iconpark-icon>
            </div>
          </a-popover>
        </template>
        <template #batch="{ checkable, checkedList }">
          <a-button
            v-if="
              [COLLECTION_MAP.PIECES, COLLECTION_MAP.PIECES_TEMPLATE].includes(
                activeKey
              )
            "
            danger
            @click="handlePurge"
          >
            {{ $t('qing-kong-shi-xiao-wen-jian') }}
          </a-button>
          <template
            v-if="
              activeKey === COLLECTION_MAP.SOURCE &&
              mediaTypeState === RESOURCE_TYPE_CONFIG.MATERIAL
            "
          >
            <TagSelect
              v-model="searchFrom.mediaType"
              name="mediaType"
              :label="$t('lei-xing')"
              type="select"
            />
          </template>
          <div v-if="checkable" class="flex-y-center gap-x-[12px] mr-[16px]">
            <a-button
              v-if="checkable"
              type="primary"
              ghost
              :disabled="checkedList.length === 0"
              :loading="loading.collection"
              @click="handlePatchCancelCollection(checkedList)"
            >
              {{ $t('qu-xiao-shou-cang') }}
            </a-button>
            <a-button
              v-if="checkable && allowDownloadVideo"
              type="primary"
              ghost
              :disabled="checkedList.length === 0"
              :loading="loading.collection"
              @click="onDownloadVideo(checkedList)"
            >
              {{ $t('xia-zai-shi-pin') }}
            </a-button>
          </div>
        </template>
        <template
          v-if="
            allowSourceFrom && hasActionPermission('my_collection_source_from')
          "
          #expand="{ dataSource }"
        >
          <SourceFrom
            :source="dataSource.source"
            :modelType="activeKey"
            :resourceType="mediaTypeState"
          ></SourceFrom>
        </template>
        <template #empty>
          <template v-if="searchFrom.keyword">
            <div class="font-medium text-16 text-font-80">
              {{ emptyText }}
            </div>
          </template>
          <template v-else>
            <div class="font-medium text-16 text-font-80">
              {{ EMPTY_TIP_MAP[activeKey].title }}
            </div>
            <div
              class="text-12 leading-[19px] text-font-60 mt-[8px] max-w-[390px]"
            >
              {{ EMPTY_TIP_MAP[activeKey].description }}
            </div>
          </template>
        </template>
      </ListCard>
    </div>
  </PageTabs>
</template>
<script lang="ts" setup>
import { isEqual, remove, throttle } from 'lodash-es'
import SourceFrom from './components/sourceFrom.vue'
import {
  cancelCollect,
  getCollectionList,
  createTaskEdit,
  createTaskTemplate,
} from '~/api'
import { postRemoveSourceIsDelete } from '~/api/module/collection.ts'
import XCollect from '@/features/collect/index.vue'
import { Eye, usePlayView } from '@/features/pageList'
import ProjectEye from '@/features/pageList/components/preview/index.vue'
import { TemplateShare } from '@/features/template/components/templateShare'

import { useVideoView } from '~/hooks/useModal/modals/view'
import { getShareUrl } from '~/hooks/useModal/modals/share'
import { useRequestAuth } from '~/hooks/useRequestAuth'
import { USER_LEVEL_KEY } from '~/api/interface/auth'
import { PAGE_SIZE } from '~/constants'
import { useTemplate } from '~/features/template/components/info'
import { showPieces } from '~/hooks/useModal/modals/piecesView'
import Collection from '~/pages/academy/collection.vue'
import { downloadOssUrl } from '~/features/oss-upload/service'

const route = useRoute()
const router = useRouter()
const list = ref<any[]>([])
const player = ref()
const total = ref(0) // 数据总条数
const activeKey = ref(
  route?.query?.model_type
    ? Number(route?.query?.model_type)
    : COLLECTION_MAP.OPUS
)
const baseSearch = {
  source: 'all',
  resolution: 'all',
  mediaType: 'all',
}
const searchFrom = reactive({ ...baseSearch, keyword: '', project: 'all' })
const mediaTypeState = ref<number>(
  route?.query?.resource_type
    ? Number(route?.query?.resource_type)
    : RESOURCE_TYPE_CONFIG.STUDIO
)
const checkList = ref<string[]>([])
const cardListRef = ref()
const loading = reactive({
  sync: false,
  collection: false,
  global: false,
})
const { $t } = useNuxtApp()
const { hasActionPermission } = usePageAndActionPermissionData()

const checkDownloadable = (dataSource: any) => {
  const canNoDown = [COLLECTION_MAP.PIECES].includes(activeKey.value)

  return !dataSource?.isDelete && dataSource?.url?.length && canNoDown
}

const handlePurge = async () => {
  const res = await postRemoveSourceIsDelete({
    model_type: activeKey.value,
  })
  message.success($t('shi-xiao-wen-jian-qing-li-cheng-gong'))
  list.value = remove(list.value, (item: any) => !res.data.includes(item.id))
  total.value = list.value.length
}

const emptyText = ref($t('ni-de-shou-cang-hui-xian-shi-zai-ci-chu'))
// const PAGE_SIZE = PAGE_SIZE
const queryParams = ref<any>({ model_type: 0 })
const userInfo = useUserInfo()

// 显示预览
const allowPreview = computed(
  () =>
    COLLECTION_MAP.SOURCE === activeKey.value &&
    [RESOURCE_TYPE_CONFIG.PERSON].includes(mediaTypeState.value)
  // ||
  // [RESOURCE_TYPE.STUDIO, RESOURCE_TYPE.PERSON].includes(mediaTypeState.value)
)

// 显示分享
const allowShare = computed(() => {
  if (
    [
      COLLECTION_MAP.OPUS,
      COLLECTION_MAP.PIECES,
      COLLECTION_MAP.PIECES_TEMPLATE,
    ].includes(activeKey.value)
  ) {
    return true
  }
  if (
    [
      RESOURCE_TYPE_CONFIG.MATERIAL,
      RESOURCE_TYPE_CONFIG.FONT,
      RESOURCE_TYPE_CONFIG.MUSIC,
      RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
      RESOURCE_TYPE_CONFIG.PASTER,
      RESOURCE_TYPE_CONFIG.STUDIO,
      RESOURCE_TYPE_CONFIG.PERSON,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL,
    ].includes(mediaTypeState.value) &&
    COLLECTION_MAP.SOURCE === activeKey.value
  ) {
    return true
  }
  return false
})

// 不分账号权限可分享
const canShare = computed(
  () =>
    mediaTypeState.value === RESOURCE_TYPE_CONFIG.PERSON &&
    COLLECTION_MAP.SOURCE === activeKey.value
)

// 显示视频播放icon
const showVideoIcon = computed(() => {
  return (
    COLLECTION_MAP.PIECES === activeKey.value ||
    (activeKey.value === COLLECTION_MAP.SOURCE &&
      [RESOURCE_TYPE.HEAD, RESOURCE_TYPE.END].includes(mediaTypeState.value))
  )
})

// 显示音频播放
const allowMusicPlay = computed(() =>
  [
    // RESOURCE_TYPE_CONFIG.TIMBRE,
    RESOURCE_TYPE_CONFIG.MUSIC,
    RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
  ].includes(mediaTypeState.value)
)

// 显示来源于
const allowSourceFrom = computed(() => {
  if (userInfo.value) {
    const isPerson = [
      USER_LEVEL_KEY.PERSONAL,
      USER_LEVEL_KEY.PERSONAL_LITE,
      USER_LEVEL_KEY.TASTE,
    ].includes(userInfo.value?.rights_type)
    return !(
      isPerson &&
      [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES].includes(activeKey.value)
    )
  }
  return (
    [
      COLLECTION_MAP.OPUS,
      COLLECTION_MAP.PIECES,
      COLLECTION_MAP.PIECES_TEMPLATE,
    ].includes(activeKey.value) ||
    [
      RESOURCE_TYPE_CONFIG.MATERIAL,
      RESOURCE_TYPE_CONFIG.FONT,
      RESOURCE_TYPE_CONFIG.MUSIC,
      RESOURCE_TYPE_CONFIG.STUDIO,
      RESOURCE_TYPE_CONFIG.PASTER,
      RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL,
    ].includes(mediaTypeState.value)
  )
})

// 支持批量下载视频
const allowDownloadVideo = computed(() =>
  [
    COLLECTION_MAP.PIECES,
    // COLLECTION_MAP.PIECES_TEMPLATE
  ].includes(activeKey.value)
)

// 视频播放埋点
const handleTracker = (click = OPEN_ENTRANCE.CARD) => {
  trackEvent(TRACK_EVENT.CLICK_PLAY_VIDEO, {
    target:
      activeKey.value === COLLECTION_MAP.OPUS
        ? TARGET_FROM.Project
        : TARGET_FROM.EV,
    source: SOURCE.RECENTLY,
    click,
  })
}

// 显示来源于
// const showSourceFilter = computed(() => {
//   const isNormal = [USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.TASTE].includes(
//     userInfo.value?.rights_type
//   )
//   return !(
//     [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES].includes(activeKey.value) &&
//     isNormal
//   )
// })

const sourceName = computed(() => {
  if (userInfo.value) {
    const isNormal = [
      USER_LEVEL_KEY.PERSONAL,
      USER_LEVEL_KEY.PERSONAL_LITE,
      USER_LEVEL_KEY.TASTE,
    ].includes(userInfo.value?.rights_type)
    return [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES].includes(
      activeKey.value
    )
      ? 'collection_source_local'
      : isNormal
      ? 'collection_source_person'
      : 'collection_source'
  }
})

// 显示来源筛选
const showSourceSelect = computed(() => {
  // 个人版-成片、作品不显示来源于
  if (
    userInfo.value &&
    [
      USER_LEVEL_KEY.PERSONAL,
      USER_LEVEL_KEY.PERSONAL_LITE,
      USER_LEVEL_KEY.TASTE,
    ].includes(userInfo.value?.rights_type) &&
    [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES].includes(activeKey.value)
  ) {
    return false
  }

  if (activeKey.value !== COLLECTION_MAP.SOURCE) {
    return true
  }

  if (
    [
      RESOURCE_TYPE_CONFIG.MATERIAL,
      RESOURCE_TYPE_CONFIG.FONT,
      RESOURCE_TYPE_CONFIG.MUSIC,
      RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
      RESOURCE_TYPE_CONFIG.PASTER,
      RESOURCE_TYPE_CONFIG.STUDIO,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL,
    ].includes(mediaTypeState.value)
  ) {
    return true
  }

  return false
})
const getCardName = () => {
  let textTip = ''
  if (activeKey.value === COLLECTION_MAP.OPUS) {
    textTip = $t('fen-xiang-kong-ge') + $t('zuo-pin')
  } else if (activeKey.value === COLLECTION_MAP.PIECES) {
    textTip = $t('fen-xiang-kong-ge') + $t('cheng-pian')
  } else if (activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE) {
    textTip = $t('fen-xiang-kong-ge') + $t('cheng-pian-mo-ban')
  } else {
    textTip =
      $t('fen-xiang-kong-ge') + RESOURCE_TYPE_MAP()[mediaTypeState.value]
  }
  return textTip
}

// 全局搜索
const handleOnSearch = (value: string) => {
  searchFrom.keyword = value
}

const onCoverClick = (record: any) => {
  if (record?.isDelete) {
    return
  }

  if (COLLECTION_MAP.PIECES === activeKey.value) {
    playVideo(record, OPEN_ENTRANCE.CARD)
  }

  if (
    activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE &&
    checkPermission(ActionListKey.COLLECTION_USE_TEMPLATE)
  ) {
    handleUseTemplate(record)
  }

  if (
    activeKey.value === COLLECTION_MAP.SOURCE &&
    [
      RESOURCE_TYPE_CONFIG.MATERIAL,
      RESOURCE_TYPE_CONFIG.PASTER,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD,
      RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL,
    ].includes(mediaTypeState.value)
  ) {
    usePlayView(record)
    return
  }
  if (activeKey.value !== COLLECTION_MAP.OPUS || record.isDelete) {
    return
  }

  trackEvent(TRACK_EVENT.OPEN_OPUS, {
    target: TARGET_FROM.Project,
    source: SOURCE.COLLECT,
    entrance: OPEN_ENTRANCE.CARD,
    permission: record.limited ? 'read' : 'edit',
  })
  window.location.href = `/editor/${record.model_id}/${record.secret_id}`
}

// 打开到编辑器
const handleOpenOpus = (record: any) => {
  trackEvent(TRACK_EVENT.OPEN_OPUS, {
    target: TARGET_FROM.EV,
    source: SOURCE.COLLECT,
    entrance: OPEN_ENTRANCE.CARD,
    permission: record.limited ? 'read' : 'edit',
  })
  let query = ''
  if (record?.generate_record_id) {
    query = `?record=${record?.generate_record_id}`
  }

  window.location.href = `/editor/${record.project_id}/${record.secret_id}${query}`
}

// 取消收藏
const cancelLike = async (record: any) => {
  const res = await cancelCollect({
    model_ids: [record.model_id],
    model_type: Number(activeKey.value),
    media_type: record.media_type,
    resource_type: record.resource_type,
    is_user_upload: record.is_user_upload,
  })
  if (!res.code) {
    message.success($t('yi-qu-xiao-shou-cang'))
    list.value = list.value.filter((item) => item.id !== record.id)
    total.value = total.value - 1
    cardListRef.value.reset()
  }
}

// 成片-打开到编辑器
// const handleOpenOpusTemplate = (record: any) => {
//   window.location.href = `/editor/${record.project_id}/${record.secret_id}`
// }

// 创作同款
const handleUseTemplate = (record: any) => {
  if (record?.model_id) {
    useTemplate({
      ...record,
      id: record?.model_id,
      copyright_limited: record.limited,
    })
  }
}
const onDownloadVideo = async (ids: number[]) => {
  const data: any = list.value.filter((item: any) => ids.includes(item.id))
  console.log(data, 'ddd')
  const downloadPromises = data.map(async (item) => {
    try {
      await downloadOssUrl(item.url?.[0], item.title)
    } catch (error) {
      console.error('Failed to download:', item.title, error)
    }
  })

  await Promise.all(downloadPromises)

  trackEvent(TRACK_EVENT.CLICK_DOWNLOAD_VIDEO, {
    source: SOURCE.COLLECT,
    Batch: ids?.length > 1 ? BATCH.ALL : BATCH.ONE,
    dataId: data.id,
    dataName: data.name,
  })

  cardListRef.value.reset()
}

// 批量取消收藏
const handlePatchCancelCollection = async (ids: number[]) => {
  const model_ids: number[] = list.value
    .filter((item) => ids.includes(item.id))
    .map((detail) => detail.model_id)

  await cancelCollect({
    ids,
  })
  message.success($t('qu-xiao-shou-cang-cheng-gong'))
  cancelReload(model_ids)
}

// 取消收藏反馈
const cancelReload = (ids: number[]) => {
  list.value = list.value.filter((item) => !ids.includes(item.model_id))
  total.value = total.value - ids.length
  cardListRef.value.reset()
}

// 弹窗内取消收藏
const reloadList = (ids: number[]) => {
  list.value = []
  total.value = 0
  handleGetSpaceList({
    model_type: activeKey.value,
    resource_type:
      activeKey.value === COLLECTION_MAP.SOURCE &&
      mediaTypeState.value !== RESOURCE_TYPE.MIX_TEXT_TEMPLATE
        ? mediaTypeState.value
        : undefined,
    resource_type__in:
      mediaTypeState.value === RESOURCE_TYPE.MIX_TEXT_TEMPLATE
        ? `${RESOURCE_TYPE_CONFIG.STATIC_TEXT_TEMPLATE},${RESOURCE_TYPE_CONFIG.DYNAMIC_TEXT_TEMPLATE}`
        : undefined,
  })
}

// 另存新作品并编辑
const onCreateTaskEdit = async (id: number) => {
  const res = await createTaskEdit({
    id,
  })

  if (!res.code && res.data) {
    message.success($t('ling-cun-xin-zuo-pin-cheng-gong'))

    window.location.href = `/editor/${res.data.id}/${res.data.secret_id}`
  }
}

// 创建成片模板
const onCreateTaskTemplate = async (id: number) => {
  const res = await createTaskTemplate({
    id,
  })
  if (!res.code) {
    message.success($t('chuang-jian-cheng-pian-mo-ban-cheng-gong'))
  }
  // handleOpenOpus(res.data)
}

const onSelectChange = (values: string[]) => {
  checkList.value = values
}

// 作品、成片模板播放视频
const playVideo = (val: any, entrance = OPEN_ENTRANCE.CARD) => {
  handleTracker(entrance)
  if (activeKey.value === COLLECTION_MAP.PIECES) {
    showPieces({
      val: { ...val, status: EXECUTION_STATUS.FINISHED },
      from: {
        target: TARGET_FROM.EV,
        source: SOURCE.COLLECT,
      },
      id: val.model_id,
      reload: reloadList,
      shareToOuterUser: hasActionPermission(
        'my_collection_share_to_outer_user'
      ),
    })
  } else {
    useVideoView(val.lastGenerate?.video_url || val.url?.[0], {
      target: getTargetForEventTracking(val.model_type, val.resource_type),
      source: SOURCE.COLLECT,
    })
  }
}

const handleOnMenuClick = (keys: { keyPath: string[] } | any, record: any) => {
  const [key, key1] = keys.keyPath
  switch (key) {
    case 'save':
      trackEvent(TRACK_EVENT.SAVE_AS_NEW_OPUS_AND_EDIT, {
        source: SOURCE.COLLECT,
      })
      onCreateTaskEdit(record.id)
      break
    case 'create':
      onCreateTaskTemplate(record.id)
      break
    case 'download':
      onDownloadVideo([record.id])
      break
    // case 'share':
    //   handleShare(record)
    //   break
    case 'open-and-locate':
      window.location.href = `/editor/${record.model_id}/${record.secret_id}?default=${key1}`
      break
    case 'play':
      playVideo(record, OPEN_ENTRANCE.MORE)
      break
    case 'open':
      handleOpenOpus(record)
      break
    default:
      break
  }
}

const handleGetSpaceList = async (values: any) => {
  loading.global = true
  cardListRef.value?.reset()
  const currentTab = activeKey.value
  const secondTab = mediaTypeState.value
  try {
    const response: any = await useRequestAuth(() =>
      getCollectionList({
        page_size: PAGE_SIZE,
        page: 1,
        ...values,
      })
    )

    if (currentTab !== activeKey.value || secondTab !== mediaTypeState.value) {
      return
    }

    if (!response.code) {
      if (response.data.next) {
        const temp = getUrlParams(response.data.next)
        queryParams.value = temp
      } else {
        queryParams.value = {}
      }

      total.value = response.data.count
      const arrData = transformList(response.data.results || []).map(
        (item: any) => ({
          ...item,
          type: getCollectionCardType(activeKey.value, mediaTypeState.value),
          avatar: item.source_user_logo_url,
          like: true,
          // name: item.source_username,
          vertical: item.isDelete ? true : item.vertical,
          time:
            activeKey.value === COLLECTION_MAP.OPUS ||
            (activeKey.value === COLLECTION_MAP.SOURCE &&
              mediaTypeState.value === RESOURCE_TYPE_CONFIG.STUDIO)
              ? $t('bian-ji-yu-timeformattextnew-datedataupdatetimegettime', [
                  item.source_time,
                ])
              : activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE
              ? $t('chuang-jian-yu-itemsourcetime', [item.source_time])
              : activeKey.value === COLLECTION_MAP.PIECES
              ? $t('dao-chu-yu-itemsourcetime', [item.source_time])
              : ![
                  // RESOURCE_TYPE_CONFIG.STUDIO,
                  RESOURCE_TYPE_CONFIG.PERSON,
                  RESOURCE_TYPE_CONFIG.TIMBRE,
                  RESOURCE_TYPE_CONFIG.SUBTITLE_TEMPLATE,
                  RESOURCE_TYPE.MIX_TEXT_TEMPLATE,
                ].includes(mediaTypeState.value) &&
                activeKey.value === COLLECTION_MAP.SOURCE
              ? $t('shang-chuan-yu-itemsourcetime', [item.source_time])
              : item.source_time,
        })
      )
      for (const item of arrData) {
        const index = list.value.findIndex(
          (record: any) => record.id === item.id
        )
        if (index === -1) {
          list.value.push(item)
        }
      }
    }
  } finally {
    loading.global = false
  }
}

const loadMore = throttle(() => {
  if (Object.keys(queryParams.value).length) {
    handleGetSpaceList(queryParams.value)
  }
}, 2000)

watch(
  [activeKey, mediaTypeState, searchFrom],
  ([tab, second, search], [oldTab, oldSecond, oldSearch]) => {
    const requestParams: any = {
      model_type: tab,
    }

    if (tab === COLLECTION_MAP.SOURCE) {
      if (second !== RESOURCE_TYPE.MIX_TEXT_TEMPLATE) {
        requestParams.resource_type = mediaTypeState.value
      } else {
        requestParams.resource_type__in = `${RESOURCE_TYPE_CONFIG.STATIC_TEXT_TEMPLATE},${RESOURCE_TYPE_CONFIG.DYNAMIC_TEXT_TEMPLATE}`
      }
    } else {
      mediaTypeState.value = RESOURCE_TYPE_CONFIG.STUDIO
    }

    if (tab !== oldTab || second !== oldSecond || isEqual(search, oldSearch)) {
      queryParams.value = {}
      list.value = []
    }
    if (tab !== oldTab || second !== oldSecond) {
      searchFrom.source = 'all'
    }

    if (search.keyword) {
      requestParams.name__icontains = search.keyword
    }

    if (
      search.source &&
      search.source !== 'all' &&
      showSourceSelect.value
      // tab !== COLLECTION_MAP.SOURCE
    ) {
      requestParams.source = searchFrom.source
    }

    if (tab === COLLECTION_MAP.SOURCE) {
      if (showSourceSelect.value) {
        if (search.mediaType !== 'all') {
          requestParams.media_type = search.mediaType
        }
      }
    }

    if (userInfo?.value?.user_id) {
      handleGetSpaceList(requestParams)
    }

    queryParams.value = requestParams
  }
)

watch(
  [() => activeKey.value, () => mediaTypeState.value],
  ([_key, _media]) => {
    if (
      Number(route.query.model_type) !== _key ||
      Number(route.query.resource_type) !== _media
    ) {
      // 路由和内容不匹配，则修改
      router.replace({
        query: {
          model_type: _key,
          resource_type: _media,
        },
      })
    }

    trackEvent(TRACK_EVENT.PAGE_COLLECTION, {
      target: getTargetForEventTracking(_key, _media),
    })
  },
  { immediate: true }
)

const EMPTY_TIP_MAP: any = {
  [COLLECTION_MAP.OPUS]: {
    title: $t('shou-cang-de-zuo-pin-hui-xian-shi-zai-ci-chu'),
    description: $t(
      'zai-ge-ren-kong-jian-tuan-dui-kong-jian-huo-yu-wo-fen-xiang-zhong-shou-cang-de-zuo-pin-du-hui-cun-fang-ci-chu-dang-qian-ye-mian-ke-dui-shou-cang-zuo-pin-guan-li'
    ),
  },
  [COLLECTION_MAP.PIECES]: {
    title: $t('shou-cang-de-cheng-pian-hui-xian-shi-zai-ci-chu'),
    description: $t(
      'zai-ge-ren-kong-jian-tuan-dui-kong-jian-huo-yu-wo-fen-xiang-zhong-shou-cang-de-cheng-pian-du-hui-cun-fang-ci-chu-dang-qian-ye-mian-ke-dui-shou-cang-cheng-pian-guan-li'
    ),
  },
  [COLLECTION_MAP.PIECES_TEMPLATE]: {
    title: $t('shou-cang-de-cheng-pian-mo-ban-hui-xian-shi-zai-ci-chu'),
    description: $t(
      'zai-ge-ren-kong-jian-tuan-dui-kong-jian-yu-wo-fen-xiang-huo-you-yan-ping-tai-zhong-shou-cang-de-cheng-pian-mo-ban-du-hui-cun-fang-ci-chu-dang-qian-ye-mian-ke-dui-shou-cang-cheng-pian-mo-ban-guan-li-zai-bian-ji-qi-zhong-ke-bian-jie-shi-yong'
    ),
  },
  [COLLECTION_MAP.SOURCE]: {
    title: $t('shou-cang-de-zi-yuan-hui-xian-shi-zai-ci-chu'),
    description: $t(
      'zai-ge-ren-kong-jian-tuan-dui-kong-jian-yu-wo-fen-xiang-huo-you-yan-ping-tai-zhong-shou-cang-de-zi-yuan-du-hui-cun-fang-ci-chu-dang-qian-ye-mian-ke-dui-shou-cang-zi-yuan-guan-li-zai-bian-ji-qi-zhong-ke-bian-jie-shi-yong'
    ),
  },
}

watch([list, searchFrom], ([values, search]) => {
  if (values.length === 0) {
    if (search.keyword) {
      emptyText.value = $t(
        'wei-sou-dao-dui-ying-nei-rong-huan-ge-guan-jian-ci-shi-shi'
      )
    } else {
      emptyText.value = $t('ni-de-shou-cang-hui-xian-shi-zai-ci-chu')
    }
  }
})

watch(
  () => route.query,
  (values: any) => {
    if (values?.model_type !== undefined) {
      activeKey.value = Number(values.model_type)
    }

    if (values?.resource_type !== undefined) {
      mediaTypeState.value = Number(values.resource_type)
    }
  }
)

onMounted(() =>
  handleGetSpaceList({
    model_type: activeKey.value,
    resource_type:
      activeKey.value === COLLECTION_MAP.SOURCE &&
      mediaTypeState.value !== RESOURCE_TYPE.MIX_TEXT_TEMPLATE
        ? mediaTypeState.value
        : undefined,
    resource_type__in:
      mediaTypeState.value === RESOURCE_TYPE.MIX_TEXT_TEMPLATE
        ? `${RESOURCE_TYPE_CONFIG.STATIC_TEXT_TEMPLATE},${RESOURCE_TYPE_CONFIG.DYNAMIC_TEXT_TEMPLATE}`
        : undefined,
  })
)

provideResourceLocation({
  source: SOURCE.COLLECT,
})
</script>
<style lang="scss">
.clear-collect-position {
  position: static !important;
}
.dark {
  .ant-dropdown-link {
    background: var(--back-1) !important;
    color: var(--white) !important;
    &:hover {
      color: var(--purple-6) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.operation {
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  > div {
    position: relative;
    height: 28px;
    width: 28px;
    &.more-menu {
      margin-left: 8px;
    }
  }
}
.content {
  @apply h-[calc(100%-95px)] relative;
  :deep(.list-card) {
    // height: calc(100% - 52px);
    height: 100%;
    overflow-y: auto;
    padding-inline-end: 10px;
    padding-block-end: 50px;
  }
  .icon-item {
    @apply flex justify-center items-center w-[28px] h-[28px] rounded-[50%] text-center cursor-pointer text-primary;
    background: $action-icon-bg;
    color: white;
    &:hover {
      background: $action-icon-bg-hover;
    }
  }
  .tool {
    @apply absolute flex gap-x-[10px] top-[10px] left-[10px];
    .collection,
    // .eye {
    //   opacity: 0;
    // }

    .favorite {
      opacity: 1;
    }
  }

  .eye,
  .collection {
    background: none;
    &:hover {
      background: none;
    }
  }

  .opus,
  .share,
  .download,
  .eye {
    @apply opacity-0;
  }
  .eye-only {
    @apply right-[10px];
  }
  .more-menu {
    @apply z-10 opacity-0;

    .ant-dropdown-link {
      @apply flex justify-center items-center w-[28px] h-[28px] m-auto rounded-full;
      background: $action-icon-bg;
      color: white;
      &:hover {
        background: $action-icon-bg-hover;
      }
    }
  }
  .template {
    @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-14 text-primary px-[11px] py-[6px] rounded-[8px] text-center cursor-pointer ease-linear opacity-0 flex-y-center;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(3px);
    transition: opacity 0.3s;

    .icon-edit {
      @apply align-middle;
    }
    .label {
      @apply ml-[4px];
    }
  }

  .source-delete {
    @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-14  px-[11px] py-[6px] rounded-[8px] text-center cursor-pointer ease-linear text-error-6 flex-y-center font-semibold;
    background: rgba(255, 240, 240, 0.8);
    backdrop-filter: blur(3px);
    transition: opacity 0.3s;
    white-space: nowrap;
    .icon-delete {
      @apply text-error-6;
    }
  }

  :deep(.base-card) {
    &:hover {
      .download,
      .collection,
      .template,
      .eye,
      .opus,
      .more-menu,
      .share,
      .play-button {
        opacity: 1;
      }
    }
  }

  .list-container {
    :deep(.ant-checkbox-group) {
      height: calc(100% - 52px);
      overflow-y: auto;
    }

    :deep(.list-card) {
      // height: calc(100vh - 280px);
      overflow-y: auto;
      padding-inline-end: 10px;
      padding-block-end: 65px;
    }
  }

  .list-source {
    height: calc(100% - 136px);
  }

  .list-person {
    :deep(.list-card) {
      .list-item {
        .card-cover {
          padding-top: 90%;
          img {
            object-fit: none;
          }
        }
      }
    }
  }
  .list-timbre {
    :deep(.list-card) {
      .list-wrapper {
        @apply grid grid-cols-8 2xl:grid-cols-10 md:grid-cols-6 gap-[14px];
      }
      // .list-item {
      //   // @apply w-[calc((100%-24px*3)/3)] 2xl:w-[calc((100%-24px*4)/4)] md:w-[calc((100%-24px*3)/2)];
      //   height: 100px;
      // }
    }
    .timbre-like {
      .collection {
        @apply w-[22px] h-[22px];
        .collect {
          @apply text-[14px]  w-[22px] h-[22px];
          box-shadow: none;
        }
      }
    }
  }

  .horizontal {
    @apply flex justify-center items-center w-[72px] h-[47px] bg-back-4 border-[1px] border-solid border-back-5;
    &:before {
      @apply w-full h-[30px] bg-back-1 border-solid border-[1px] border-back-5 my-[8px];
      content: '';
    }
  }
  .vertical {
    @apply flex justify-center items-center w-[72px] h-[47px] bg-back-4 border-[1px] border-solid border-back-5;
    &:before {
      @apply w-[32px] h-full bg-back-1 border-solid border-[1px] border-back-5 my-[8px];
      content: '';
    }
  }
}
</style>
